module.exports = __webpack_public_path__ + "img/tablet.97a81efb.png";